<template>
  <div>
    <basic-container>
      <div style="height: 20px"></div>
      <el-form :inline="true" ref="form" :model="form">
        <el-row>
          <el-col span="6">
            <el-form-item label="项目名称" style="width: 100%; display: flex">
              <el-select
                style="width: 100%; flex: 1"
                v-model="form.projectId"
                placeholder="项目"
                size="small"
              >
                <el-option
                  v-for="(item, index) in projectIdList"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col span="6">
            <el-form-item label="设备类型" style="width: 100%; display: flex">
              <el-select
                style="width: 100%; flex: 1"
                v-model="form.typeId"
                placeholder="设备类型"
                size="small"
              >
                <el-option :value="form.typeId" show-all-levels :label="form.typeName">
                  <el-tree
                    v-if="form.projectId"
                    node-key="id"
                    :data="treeFormData"
                    :props="treeProps"
                    :load="typeLazyLoadTree"
                    lazy
                    @node-click="typeNodeTreeClick"
                  >
                  </el-tree>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col span="6">
            <el-form-item>
              <el-button type="primary" @click="onSubmit">搜索</el-button>
              <el-button type="primary" @click="searchReset">清空</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <WebReport ref="WebReport" :url="url" :params="params"/>
    </basic-container>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import urlSettings from '@/config/url-settings';
  import WebReport from '@/components/web-report';
  import {getProjectList} from "@/api/crmedical/report/questionnaire.js";
  import {getTree} from "@/api/crmedical/device/devicetype";
  import {
    add,
    getDetail,
    getList,
    remove,
    update,
    childNode,
    userList,
    copyDevice,
    getTableStructure,
    submitFormData,
    deviceExport,
    getProjectDept
  } from "@/api/crmedical/device/device";
  export default {
    components: {
      WebReport,
    },
    data() {
      return {
        treeProps: {
          //标题
          label: 'name',
          //值
          value: 'id',
          //子节点
          children: 'zones',
          //是否叶子节点
          isLeaf: 'hasChildren',
          //本节点类型key值
          objectType: 'id',
          //本节点类型名
          objectTypeName: 'name',
        },
        typeNameFlag: true,
        typeIdFlag: false,
        treeFormData: [],
        deptList:[],
        typeList:[],
        url: '',
        form: {
          projectId: "",
          deptId: "",
          typeId: "",
        },
        projectList: [],
        oldOptions: [],
        params: {
          reportlet:urlSettings.VUE_APP_ENVIRONMENT +  '/upkeepAndInspectReport.cpt',
          //  reportlet: 'oweSummary.cpt',
        },
        dic: [],
      };
    },
    watch:{
      'form.projectId': function (val,oldVal) {
        if(val){
          //获取部门
          getProjectDept({projectId: val}).then(({data}) => {
            this.form.deptId = "";
            this.deptList = data;
          });
          //获取设备类型
          getTree({id:0, projectId:val}).then(({data}) => {
            this.form.typeName = "";
            this.form.typeId = "";
            if (data instanceof Array) {
              data.forEach(item => {
                item.hasChildren = !item.hasChildren;
              })
            } else {
              data = [];
            }
            this.treeFormData = data;
          });

        }
      },
    },
    methods: {
      typeLazyLoadTree(node, resolve) {
        let id;
        if (node.level === 0) {
          id = 0;
        } else {
          id = node.data.id;
          getTree({id, projectId: this.form.projectId}).then(({data}) => {
            if (data instanceof Array) {
              data.forEach(item => {
                item.hasChildren = !item.hasChildren;
              })
            } else {
              data = [];
            }
            resolve(data);
          });
        }
      },
      typeNodeTreeClick(node) {
        let nodeId = node.id;
        let nodeTitle = node.name;
        if (this.form.projectId) {
          this.form.typeName = nodeTitle;
          this.form.typeId = nodeId;
        } else {
          this.query.typeName = nodeTitle;
          this.query.typeId = nodeId;
        }
        this.typeNameFlag = true;
        this.typeIdFlag = false;
      },
      onSubmit() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.params.projectId = this.form.projectId;
            this.params.typeId = this.form.typeId;

            setTimeout(() => {
              this.$refs.WebReport.regroupUrl();
            }, 0);
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      searchReset(){
        if (this.projectIdList.length > 0) {
          this.form.projectId = this.projectIdList[0].id;
        }
        this.form.typeName = "";
        this.form.typeId = "";
        this.onSubmit();
      },

      initPropertyList() {
        getProjectList({}).then((res) => {
          this.projectIdList = res.data;
          if (this.projectIdList.length > 0) {
            this.form.projectId = this.projectIdList[0].id;
          }

          var reportUrl = urlSettings.BASE_REPORT_URL;
          this.url = reportUrl.split('?')[0];
          //this.url = 'http://localhost:8075/WebReport/ReportServer?reportlet=upkeepAndInspectReport.cpt';

          this.params.projectId = `${this.projectIdList[0].id}`;

          setTimeout(() => {
            this.$refs.WebReport.regroupUrl();
          }, 0);
        });
      },
    },

    created() {
      this.initPropertyList();
    },
  };
</script>

<style></style>
